import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32bef175"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "me-5"
}
const _hoisted_2 = { class: "text-math-auto" }

import { withDefaults, ref, watch, onMounted, onBeforeMount } from 'vue';
import { ITab } from '@/types';
import * as comps from '@/components/atoms';
interface IProps {
  modelValue: string;
  tabs: ITab[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTabs',
  props: {
    modelValue: { default: '' },
    tabs: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const computedStyles = getComputedStyle(document.documentElement);
const primaryC100 = computedStyles.getPropertyValue('--primary-c100');

const props = __props;
const tab = ref('');
const tabs = ref<ITab | any>();
const hoverTab = ref('');

function updateTab() {
  emit('update:modelValue', tab.value);
}

watch(
  () => tab.value,
  () => {
    updateTab();
  }
);

onBeforeMount(() => {
  tabs.value = props.tabs.filter((value) => value.permission !== false)
})

onMounted(() => {
  if (props.modelValue) tab.value = props.modelValue;
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createBlock(_component_v_tabs, {
    modelValue: tab.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
    color: "var(--primary-c100)",
    class: "w-100 line-accordion"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (itemTab) => {
        return (_openBlock(), _createBlock(_component_v_tab, {
          value: itemTab.value,
          key: itemTab.value,
          class: "text-muted text-md justify-space-between",
          onMouseover: ($event: any) => (hoverTab.value = itemTab.value),
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoverTab.value = ''))
        }, {
          default: _withCtx(() => [
            (itemTab.icon)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(comps[itemTab.icon]), {
                    color: tab.value == itemTab.value || itemTab.value == hoverTab.value ? `${_unref(primaryC100)}` : ''
                  }, null, 8, ["color"]))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_2, _toDisplayString(itemTab.label), 1)
          ]),
          _: 2
        }, 1032, ["value", "onMouseover"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})